export default __webpack_public_path__ + "static/media/Tabela_de_Honorarios_11-12-20.513b7e30.pdf";